import { httpService } from "./HttpService";
import ApiPaths from "./ApiPaths";
import { User } from "../models/User";
import { UserCreateRequest } from "../models/UserCreateRequest";
import { UserEditRequest } from "../models/UserEditRequest";

export const getMe = async (): Promise<User> => {
    const response = await httpService.get<User>(ApiPaths.USERS_ME);
    return response.data;
}

export const listAllUsers = async (): Promise<User[]> => {
    try {
        const response = await httpService.get<User[]>(ApiPaths.USERS);
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
}

export const createUser = async (user: UserCreateRequest): Promise<void> => {
    try {
        await httpService.post(ApiPaths.CREATE_USER, user);
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
}

export const editUser = async (userId: string, user: UserEditRequest): Promise<void> => {
    try {
        await httpService.put(`${ApiPaths.EDIT_USER}/${userId}`, user);
    } catch (error) {
        console.error('Error editing user:', error);
        throw error;
    }
}

export const deleteUser = async (userId: string): Promise<void> => {
    try {
        await httpService.delete(`${ApiPaths.DELETE_USER}/${userId}`);
    } catch (error) {
        console.error('Error deleting user:', error);
        throw error;
    }
}

export const resendInvite = async (userId: string): Promise<void> => {
    try {
        await httpService.post(`${ApiPaths.RESEND_INVITE}/${userId}/resend-invite`, {});
    } catch (error) {
        console.error('Error resending invite:', error);
        throw error;
    }
}